import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { adminApi } from "@/lib/api";

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    icon_base64: null,
    company_name: "VIDOC",
    company_tagline: null,
  });
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      // Public branding endpoint — works both before AND after login (the
      // admin-gated /admin/icons returned 401 on the Login page, which is
      // why the company logo never showed there).
      const data = await adminApi.publicBranding();
      setBranding({
        icon_base64: typeof data.icon_base64 === "string" && data.icon_base64.length > 10 ? data.icon_base64 : null,
        company_name: data.company_name || "VIDOC",
        company_tagline: data.company_tagline || null,
      });
    } catch (e) {
      console.warn("[BrandingContext] Failed to load branding", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const value = useMemo(
    () => ({ ...branding, loading, refresh }),
    [branding, loading],
  );

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be used within BrandingProvider");
  return ctx;
}
